import { ROUTE_DOCS_AGRO_TECHNICAL_EVENTS } from '@/common/constants';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import useAgroTechnicalEventsStore from '../store/useAgroTechnicalEventsStore';
import AgrotechFilter from './AgrotechFilter';
import { AgroTechnicalEventsSidebar } from './AgroTechnicalEventsSidebar';

export default function AgroTechnicalEventsWrapper() {
  const { districtId, masterId } = useParams();
  const {
    agroTechnicalEventsList,
    fetchAgroTechnicalEvents,
    agroTechnicalEventsListLoading,
  } = useAgroTechnicalEventsStore();

  useEffect(() => {
    fetchAgroTechnicalEvents(districtId!, masterId!);
  }, []);

  return (
    <div className="h-screen w-full bg-gray-100 overflow-auto">
      <div className="flex h-full">
        <AgroTechnicalEventsSidebar
          items={agroTechnicalEventsList}
          isLoading={agroTechnicalEventsListLoading}
        />
        <div className="flex flex-1 flex-col overflow-hidden bg-gray-100">
          <AgrotechFilter
            page={ROUTE_DOCS_AGRO_TECHNICAL_EVENTS}
            className="border-b border-gray-200 bg-white py-2 pr-10 pl-6 shrink-0"
          />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
